import React from 'react';
import { Field, Formik } from 'formik';
import PropTypes from 'prop-types';
import Pagination from '../Pagination/Pagination';
import Select from '../Select/Select';
import Grid from '../Grid/Grid';


const DataTablePagination = (props) => {
    const {
        isLoading,
        onPageChange,
        onNumberOfItemsChange,
        pageable,
        page: {
            count,
            number,
            size,
        },
    } = props;
    const current = number + 1;
    const total = count || 0;
    const showPagination = pageable && total > 1;

    const initialValues = {
        itemsPerPage: size ? `${size}` : '20',
    };
    const itemSizeOptions = [{
        value: '20',
        name: '20',
    }, {
        value: '40',
        name: '40',
    }, {
        value: '60',
        name: '60',
    }, {
        value: '80',
        name: '80',
    }, {
        value: '100',
        name: '100',
    }];

    return (
        showPagination ?
            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-end' }}>
                <Formik initialValues={initialValues}>
                    <form>
                        <Grid>
                            <Grid.Row>
                                <Field
                                    component={Select}
                                    name="itemsPerPage"
                                    onSelect={(value) => {
                                        onNumberOfItemsChange(value);
                                    }}
                                    required
                                    clearable={false}
                                    label="Number of Items Per Page"
                                    options={itemSizeOptions}
                                />
                            </Grid.Row>
                        </Grid>
                    </form>
                </Formik>
                <Pagination
                    current={current}
                    isDisabled={isLoading}
                    onPageChange={onPageChange}
                    total={total}
                />
            </div>

            :
            null
    );
};

DataTablePagination.propTypes = {
    isLoading: PropTypes.bool.isRequired,
    onPageChange: PropTypes.func.isRequired,
    onNumberOfItemsChange: PropTypes.func,
    pageable: PropTypes.bool.isRequired,
    page: PropTypes.shape({
        count: PropTypes.number,
        number: PropTypes.number,
    }).isRequired,
};
DataTablePagination.defaultProps = {
    onNumberOfItemsChange: () => { },
}

export default DataTablePagination;
